export default __webpack_public_path__ + "assets/a2.9d099eb1.jpg";